export const HierarchyStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "25px",
    padding: "25px 30px",
    minHeight: "calc(100vh - 120px)",
    background:
      "linear-gradient(180deg, var(  --support-green) 0%, var( --support-blue) 100%)",
    marginTop: "68px",
    "@media screen and (max-width: 1023px)": {
      padding: "40px",
      gap: "15px",
      marginTop: "60px",
    },
    "@media screen and (max-width: 599px)": {
      padding: "23px 20px",
      gap: "15px",
    },
  },
  hierarchyContainer: {
    maxWidth: "100%",
    marginTop: "0px",
  },
  paddingContainer: {
    padding: 4,
  },
  rootNodeCard: {
    textAlign: "center",
    padding: 2,
    backgroundColor: "#e3f2fd",
    borderRadius: "12px",
    height: "100px",
  },
  rootNodeIcon: {
    fontSize: 40,
    color: "#1e88e5",
  },
  rootNodeText: {
    color: "#1e88e5",
  },
  branchCard: {
    textAlign: "center",
    padding: 2,
    backgroundColor: "#f3e5f5",
    borderRadius: "12px",
    height: "100px",
  },
  branchIcon: {
    fontSize: 32,
    color: "#8e24aa",
  },
  branchText: {
    color: "#8e24aa",
  },
  childNodeContainer: {
    marginTop: 4,
  },
  subNodeContainer: {
    marginTop: 2,
  },
  subNodeCard: {
    textAlign: "center",
    padding: 2,
    backgroundColor: "#e8f5e9",
    borderRadius: "12px",
  },
  subNodeIcon: {
    fontSize: 28,
    color: "#43a047",
  },
};
